import React, { useState } from 'react';
import ScrollPosition from '../hook/ScrollPosition';
import axios from 'axios';

//
import { API_URL } from '../config/Constant';

// ANT 디자인 컴포넌트
import { Button, Input, Upload, message } from "antd"

// 아이콘 import
import { AiFillCamera } from "react-icons/ai"






// const { TextArea } = Input
const Marketplace = () => {

   const scrollPosition = ScrollPosition()
   // 좌측 HideBox 클릭시, 목적어 display none
   const [isUploadFormVisible, setUploadFormVisible] = useState(true);
   const handleToggleUploadForm = () => {
     setUploadFormVisible(prevState => !prevState);
   };



   // 상품 등록 관련
   const [imageUrl, setImageUrl] = useState(null)

   const onSubmit = (values) => {
      console.log("Success:", values)
      axios.post(`${API_URL}/product`, {
         name : values.name,
         description : values.description,
         seller : values.seller,
         phone : parseInt(values.phone),
         price: parseInt(values.price),
         imageUrl : imageUrl
      }).then(result=>{
         console.log(result)
         // history('/', {})
      }).catch(error=>{
        console.error(error)
        message.error(`에러가 발생했습니다. ${error.message}`)
      })
   }

   const onChangeImage = (info) => {
      if(info.file.status==="uploading"){
         return
      }
      if(info.file.status==="done"){
         const response = info.file.response
         const imageUrl = response.imageUrl
         setImageUrl(imageUrl)
      }
   }


   return (
      <div id='Marketplace' className="flexCenter">
         <div className="inner">
            <div className="Market-Notice">
               <div className="flexCenter">
                  <img src={require("../img/Marketplace1.jpg")} alt="" />
               </div>
               <div>
                  <h1>Marketplace </h1>
                  <h2>세상 모든 물건에 가치를 소비를 지속 가능하게</h2>
                  <p>구하지 못했던 한정판 굿즈, 전국에 있는 내 취향의 브랜드 상품, 삶을 더 똑소리나게 만들어 줄 IT 기기, 입으면 기분이 절로 좋아지는 옷, 바라만 보아도 흐뭇한 스니커즈, 최애 아이돌과 나를 이어줄 수많은 잡화들까지.</p>
                  <p>LCDC는 내가 좋아하는 것들로 일상이 채워질 때, 우리 모두가 더 행복해질 수 있다고 믿습니다. </p>
                  <p className="mb30">저마다의 취향이라는 세계 속에서 모두가 행복해질 수 있도록, 오늘도 LCDC는 더 쉽고 안전한 개인간 거래를 만들어갑니다.</p>
                  <span>에스크로 안전거래 & 무통장입금 & 네이버페이 지원</span>
                     
               </div>
            </div>
   
            <div className={`Market ${scrollPosition >= 200 ? 'originPosition' : ''}`}>
               <div className="HideBox" onClick={handleToggleUploadForm}>
                  <img src={require("../img/logo/ico_mouse.png")} alt="" />
                  <span>HIDE</span>
               </div>
               {/* ■■■■ 마켓 상품 등록 폼 ■■■■ */}
               {/* 문제사항 : form으로 감싸면 사진은 업로드 안되지만 뭔가는 올라가는 것 같음
               form을 지우면 사진만 업로드됨. */}
               {isUploadFormVisible && (
               <div className='uploadForm'  >
                  <form onSubmit={onSubmit}>
                       <Upload name='image' action={`${API_URL}/image`} listType='pic'
                       showUploadList={false} onChange={onChangeImage}>
                         <div className='imgBox'>
                           {imageUrl ? (
                             <>
                               <img src={`${API_URL}/${imageUrl}`} alt='업로드 이미지' />
                               <span>이미지 수정</span>
                             </>
                           ) : (
                             <>
                               <AiFillCamera className='iconCamera' />
                               <span>이미지 업로드</span>
                             </>
                           )}
                         </div>
                       </Upload>

                     <label name=''>
                        상품명
                        <Input className='' placeholder='상품명을 입력해주세요' size='large'/>
                     </label>
         
         
                     <label name=''>
                        판매자명
                        <Input className='' placeholder='판매자명을 입력해주세요' size='large'/>
                     </label>
         
                     <label name=''>
                        연락처
                        <Input className='' placeholder='연락처는 구매자에게만 보여집니다' size='large'/>
                     </label>
         
                     <label name=''>
                        판매가
                        <Input className='' placeholder='0' size='large'/>
                     </label>
         
                     <label name='' className="mb30">
                        상품설명
                        <Input className='' placeholder='상품설명을 작성해주세요' size='large'/>
                     </label>
                     <Button id='submit-button' htmlType='submit'>상품등록하기</Button>
                  </form>
               </div>
               )}


               {/* 마켓 상품 진열대 */}
               <div className="marketData" style={{ width: isUploadFormVisible ? '75%' : '100%' }}>
                  <ul>
                     <li style={{ flexBasis: isUploadFormVisible ? '25%' : '20%' }}>
                        <h3>독버섯 조명</h3>
                        <h3>38,000원</h3>
                     </li>
                     <li style={{ flexBasis: isUploadFormVisible ? '25%' : '20%' }}>
                        <h3>까사 테이블</h3>
                        <h3>398,000원</h3>
                     </li>
                     <li style={{ flexBasis: isUploadFormVisible ? '25%' : '20%' }}>
                        <h3>헥슬라 티컵</h3>
                        <h3>76,000원</h3>
                     </li>
                     <li style={{ flexBasis: isUploadFormVisible ? '25%' : '20%' }}>
                        <h3>알타니 거울</h3>
                        <h3>83,000원</h3>
                     </li>
                     <li style={{ flexBasis: isUploadFormVisible ? '25%' : '20%' }}>
                        <h3>가르뎅 침구</h3>
                        <h3>110,000원</h3>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Marketplace
